import React from 'react'

import { ButtonCtr } from 'common/builder/components/chart/FlowChart/components/Button/ButtonCtr/ButtonCtr'
import { ButtonInfo } from 'common/builder/components/chart/FlowChart/components/Button/ButtonInfo/ButtonInfo'
import { ButtonContentComponent } from 'common/builder/components/chart/FlowChart/components/Button/types'

import * as styles from './TextButtonContent.styles'

export const TextButtonContent: ButtonContentComponent = ({ button, isHover }) => {
  const textStyle = isHover ? styles.textStyleHover : styles.textStyle

  return (
    <view style={styles.wrapper}>
      <view style={styles.textContainer}>
        <richtext style={textStyle} text={button.caption} />
      </view>
      <ButtonCtr button={button} background="transparent" />
      <ButtonInfo button={button} />
    </view>
  )
}
